import type { AxiosError } from 'axios'
import axios from 'axios'

import type {
  ControllerConfigTypeId,
  ControllerConfigVersion,
  ControllerConfigVersionUpdate,
} from '@/features/controller/configuration/types'
import { BASE_DEVICE_MANAGEMENT_API_URL } from '@/features/controller/endpoints/controllers'
import type { ControllerRestartMethod } from '@/features/controller/restart/types'

export const GET_CONFIG_VERSION_API = 'GET_CONFIG_VERSION'
export const GET_LATEST_CONFIG_VERSION_API = 'GET_LATEST_CONFIG_VERSION'

export type getControllerConfigLatestVersionParams = {
  controllerId: string
  configTypeId: ControllerConfigTypeId
}

export async function getControllerConfigLatestVersion(
  params: getControllerConfigLatestVersionParams,
): Promise<ControllerConfigVersion | null> {
  try {
    const response = await axios.get(
      `${BASE_DEVICE_MANAGEMENT_API_URL}/controllers/${params.controllerId}/configurations/${params.configTypeId}`,
    )
    return response.data
  } catch (e) {
    if ((e as AxiosError).status === 404) {
      return null
    }
    throw e
  }
}

export async function updateControllerConfigLatestVersion(
  controllerId: string,
  configTypeId: ControllerConfigTypeId,
  payload: ControllerConfigVersionUpdate,
): Promise<ControllerConfigVersion> {
  const response = await axios.put(
    `${BASE_DEVICE_MANAGEMENT_API_URL}/controllers/${controllerId}/configurations/${configTypeId}`,
    payload,
  )
  return response.data
}

export async function getControllerConfigVersion(id: string): Promise<ControllerConfigVersion | null> {
  try {
    const response = await axios.get(`${BASE_DEVICE_MANAGEMENT_API_URL}/configuration-versions/${id}`)
    return response.data
  } catch (e) {
    if ((e as AxiosError).status === 404) {
      return null
    }
    throw e
  }
}

export async function restartController(controllerId: string, restartMethod: ControllerRestartMethod): Promise<void> {
  const response = await axios.post(
    `${BASE_DEVICE_MANAGEMENT_API_URL}/controllers/${controllerId}/restart?restartMethod=${restartMethod}`,
  )
  return response.data
}
